/* The guide page: the contents list from the body's own headings, the shock calculator, the closing
 * sizers and the pool heater calculator.
 * One function scope, like every other APS script. */
(() => {
  function toc() {
    var src = document.querySelector('[data-toc-source]'); if (!src) return;
    // The pool heater calculator sits between the short answer and the article, so its heading comes first.
    var heads = [].slice.call(document.querySelectorAll('.gd-main > .gd-hc h2')).concat([].slice.call(src.querySelectorAll('h2, h3')), [].slice.call(document.querySelectorAll('.gd-main > h2')));
    var items = heads.filter(function (h) { return h.id && h.textContent.trim(); }).map(function (h) {
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim();
      var li = document.createElement('li'); li.appendChild(a); return li;
    });
    document.querySelectorAll('[data-toc-list]').forEach(function (ol) {
      ol.innerHTML = ''; items.forEach(function (li) { ol.appendChild(li.cloneNode(true)); });
    });
    if (!items.length) document.querySelectorAll('[data-toc-mobile],[data-toc-desktop]').forEach(function (n) { n.hidden = true; });
  }
  function calc() {
    document.querySelectorAll('[data-gc]').forEach(function (box) {
      if (box.tagName !== 'DIV') return;
      var sel = function (k) { return box.querySelector('[data-gc="' + k + '"]'); };
      var fmt = function (x) { return (Math.round(x * 10) / 10).toString(); };
      var bags = function (x) { var b = Math.ceil(x); return b + ' bag' + (b === 1 ? '' : 's'); };
      var names = { calhypo: sel('kind').options[0].textContent, dichlor: sel('kind').options[1].textContent, mps: sel('kind').options[2].textContent };
      function run() {
        var gal = +sel('gal').value, kind = sel('kind').value, sit = sel('sit').value, per = gal / 10000, out = sel('out');
        if (kind === 'mps' && sit === 'green') {
          out.innerHTML = '<b>Non-chlorine shock is not a sanitizer.</b> Green water is a chlorine job: ' + fmt(per * 2) + ' to ' + fmt(per * 3) + ' lb of ' + names.calhypo + ' or ' + names.dichlor + ' per treatment, then an algaecide once it clears.';
          return;
        }
        if (sit === 'green') out.innerHTML = '<b>' + fmt(per * 2) + ' to ' + fmt(per * 3) + ' lb</b> of ' + names[kind] + ' per treatment, ' + bags(per * 2) + ' to ' + bags(per * 3) + ' of 1 lb, repeated daily until the water holds chlorine overnight.';
        else out.innerHTML = '<b>' + fmt(per) + ' lb</b> of ' + names[kind] + ' once a week: ' + bags(per) + ' of 1 lb for a ' + gal.toLocaleString() + ' gallon pool.';
      }
      box.querySelectorAll('select').forEach(function (s) { s.addEventListener('change', run); });
      run();
    });
  }
  // The closing sizer (the winterizing guide). The pillow is Dylan's approved table (2026-09-21; the 4 x 4 ft replaced
  // the out of stock 4 x 5 ft for the small pools on 2026-09-22), from the
  // pillow makers' sizing chart; the size page handles are the above ground cover size pages.
  function sizer() {
    document.querySelectorAll('[data-sizer]').forEach(function (z) {
      var q = function (k) { return z.querySelector('[data-z="' + k + '"]'); };
      var lists = {}; (z.dataset.sizes || '').split(';').forEach(function (part) { var kv = part.split(':'); if (kv[1]) lists[kv[0]] = kv[1].split(','); });
      if (!lists.round) return;
      var sh = q('shape'), sz = q('size'), wl = q('wall'), out = q('out');
      function pillow(shape, s) {
        if (shape === 'round') { var n = +s; return n <= 16 ? '4 x 4 ft' : n <= 24 ? '4 x 8 ft' : '4 x 15 ft'; }
        if (s === '12x18') return '4 x 4 ft';
        return +s.split('x')[0] >= 18 ? '4 x 15 ft' : '4 x 8 ft';
      }
      function page(shape, s) { return '/collections/' + (shape === 'round' ? s + '-ft-round' : s.replace('x', '-x-') + '-ft-oval') + '-above-ground-winter-covers'; }
      function fill() {
        var l = lists[sh.value] || [], keep = sz.value;
        sz.innerHTML = l.map(function (s) { return '<option value="' + s + '">' + (sh.value === 'round' ? s + ' ft' : s.replace('x', ' x ') + ' ft') + '</option>'; }).join('');
        sz.value = l.indexOf(keep) >= 0 ? keep : (sh.value === 'round' ? '24' : '15x30');
        if (!sz.value && l.length) sz.value = l[0];
      }
      function run() {
        var d = wl.value === '48' ? 3.5 : 4, s = sz.value, g;
        if (sh.value === 'round') g = (+s) * (+s) * d * 5.9; else { var p = s.split('x'); g = (+p[0]) * (+p[1]) * d * 6.7; }
        g = Math.round(g / 100) * 100;
        var big = g > 15000, kitUrl = big ? z.dataset.kit30 : z.dataset.kit15, kitSize = big ? '30K gallon' : '15K gallon';
        if (g > 30000) kitSize = '30K plus 15K gallon';
        out.innerHTML = '<div><span>Water</span><b>about ' + g.toLocaleString() + ' gal</b></div>' +
          '<div><span>Closing kit</span><b>' + kitSize + '</b></div>' +
          '<div><span>Air pillow</span><b>' + pillow(sh.value, s) + '</b></div>' +
          '<a href="' + page(sh.value, s) + '">Covers for this pool</a>' +
          (kitUrl ? '<a class="alt" href="' + kitUrl + '">' + (z.dataset.kitName || 'Closing kit') + ', ' + kitSize + '</a>' : '');
      }
      sh.addEventListener('change', function () { fill(); run(); });
      sz.addEventListener('change', run); wl.addEventListener('change', run);
      fill(); run();
    });
  }
  // Water tubes for a solid inground winter cover, Dylan's approved rule (2026-09-22). The tubes lie on the
  // cover, on the deck, so the run they have to cover is the COVER's edge, not the pool's: a solid inground
  // cover is cut to the pool plus 5 ft, so the run is 2 x ((w + 5) + (l + 5)). Tubes go end to end, which is
  // the only spacing a manufacturer states (GLI), so the count is that run divided by the tube length,
  // rounded up. Published charts that count the pool's own perimeter land about 3 tubes lower on every size;
  // that gap is the 20 ft of extra edge, not a different rule. Corner tubes are recommended and not counted:
  // sources call them optional. docs/ops/2026-09-22-igwc-guide/rules.md, section 1.
  function tubeRun(w, l) { return 2 * ((w + 5) + (l + 5)); }
  function tubes(w, l) {
    var run = tubeRun(w, l);
    return Math.ceil(run / 8) + ' x 8 ft, or ' + Math.ceil(run / 10) + ' x 10 ft';
  }

  // The inground closing sizer. Same panel, different inputs: every inground cover we stock is a rectangle,
  // so there is no shape, and there is no wall height either. An inground pool slopes, so the average depth
  // is a guess whichever way it is done; it is a select here rather than a constant hidden in the formula.
  // Gallons: length x width x average depth x 7.5. Tube counts: see tubes(), the approved rule.
  function igsizer() {
    document.querySelectorAll('[data-igsizer]').forEach(function (z) {
      var q = function (k) { return z.querySelector('[data-z="' + k + '"]'); };
      var sizes = (z.dataset.sizes || '').split(',').filter(Boolean);
      if (!sizes.length) return;
      var sz = q('size'), dp = q('depth'), out = q('out');
      function page(s) { return '/collections/' + s.replace('x', '-x-') + '-ft-inground-winter-covers'; }
      function kit(g) {
        if (g <= 15000) return { text: '15K gallon', url: z.dataset.kit15 };
        if (g <= 30000) return { text: '30K gallon', url: z.dataset.kit30 };
        var n = Math.floor(g / 30000), rem = g - n * 30000;
        if (rem > 15000) { n += 1; rem = 0; }
        var parts = [(n === 1 ? '' : n + ' x ') + '30K gallon'];
        if (rem > 0) parts.push('15K gallon');
        return { text: parts.join(' plus '), url: z.dataset.kit30 };
      }
      function run() {
        var p = sz.value.split('x'), w = +p[0], l = +p[1], d = +dp.value;
        var g = Math.round(w * l * d * 7.5 / 100) * 100, k = kit(g), t = tubes(w, l);
        out.innerHTML = '<div><span>Water</span><b>about ' + g.toLocaleString() + ' gal</b></div>' +
          '<div><span>Closing kit</span><b>' + k.text + '</b></div>' +
          '<div><span>Water tubes</span><b>' + t + '</b></div>' +
          '<a href="' + page(sz.value) + '">Covers for this pool</a>' +
          (k.url ? '<a class="alt" href="' + k.url + '">' + (z.dataset.kitName || 'Closing kit') + ', ' + k.text + '</a>' : '') +
          (z.dataset.tubeUrl ? '<a class="alt" href="' + z.dataset.tubeUrl + '">How many water tubes?</a>' : '');
      }
      sz.innerHTML = sizes.map(function (s) { return '<option value="' + s + '">' + s.replace('x', ' x ') + ' ft</option>'; }).join('');
      sz.value = sizes.indexOf('20x40') >= 0 ? '20x40' : sizes[0];
      sz.addEventListener('change', run); dp.addEventListener('change', run);
      run();
    });
  }
  // The pool heater size calculator (2026-09-29), snippets/aps-heater-calc.liquid. The method is the one
  // the sizing guide describes step for step, and every constant is sourced in
  // docs/ops/2026-09-29-heater-guides/facts-heaters.md.
  //
  // GAS        output needed = surface area x rise x 12          Department of Energy: 1 to 1-1/4F an hour,
  //                            x 1.25 at about 5 mph, x 2 at 10  3.5 mph wind. Wind: Hayward and Coates
  //            gas input     = output / 0.82                     Raypak's stated efficiency, the federal minimum
  //            heat-up hours = gallons x 8.34 x rise / (size x 0.82)             Pentair's volume method
  // HEAT PUMP  daily heat    = gallons x 8.3 x rise x cover x wind               AquaCal's operating cost worksheet:
  //                            cover 0.5 none, 0.3 liquid, 0.2 blanket. Its wind factor is 1 to 3.5 mph and 1.25
  //                            from 3.6 to 5 mph, for a pool with no blanket, and it prints nothing above 5 mph.
  //                            So under a blanket the factor is 1, and at 10 mph it is held at 1.25 and the
  //                            result says so.
  //            size          = daily heat / the hours a day the READER lets it run, then the next size up. The
  //                            worksheet returns run time for a unit already chosen and never a size: the run
  //                            hours are the reader's choice and the division is ours. Default 24, the one
  //                            figure a maker gives (Raypak: a heat pump may run up to 24 hours a day).
  // The sizes are the ones heaters are sold in, not products: the button goes to the collection.
  function heat() {
    var GAS = [105000, 150000, 200000, 266000, 333000, 399000];
    var HP = [50000, 65000, 85000, 102000, 118000, 138000, 143000];
    var EFF = 0.82;
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    var hours = function (h) { return (Math.round(h * 10) / 10) + ' hours'; };
    document.querySelectorAll('.gd-hc[data-hc]').forEach(function (root) {
      var out = root.querySelector('[data-hc="out"]');
      var v = function (k) { return parseFloat(root.querySelector('[data-hc="' + k + '"]').value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go(text, href) { var a = el('a', 'go', text); a.href = href; out.appendChild(a); }
      function run() {
        var L = v('len'), W = v('wid'), D = v('dep'), want = v('want'), air = v('air'), wind = v('wind');
        var kind = root.querySelector('[data-hc="kind"]').value;
        root.querySelectorAll('[data-hc-hp]').forEach(function (e) { e.hidden = kind !== 'hp'; });
        root.querySelectorAll('[data-hc-fn]').forEach(function (e) { e.hidden = e.getAttribute('data-hc-fn') !== kind; });
        while (out.firstChild) out.removeChild(out.firstChild);
        if (!(L > 0 && W > 0 && D > 0) || isNaN(air)) { msg('Enter the pool\'s length and width and the air temperature.'); return; }
        var area = L * W, gal = area * D * 7.5, rise = want - air;
        row('Surface area', fmt(area) + ' sq ft');
        row('Pool volume', fmt(gal) + ' gallons');
        if (rise <= 0) { row('Temperature rise', 'none'); msg('The air in that month is already as warm as the water you want, so the pool needs no heater to hold it.'); return; }
        row('Temperature rise', fmt(rise) + 'F');
        var need = area * rise * 12 * wind;
        row(kind === 'gas' ? 'Heat output needed' : 'To gain 1 to 1-1/4F an hour', fmt(need) + ' BTU an hour');
        if (kind === 'gas') {
          var input = need / EFF;
          row('Input rating at 82 percent', fmt(input) + ' BTU');
          var size = GAS.filter(function (s) { return s >= input; })[0];
          if (!size) {
            big('Heater size', 'Over 399,000 BTU');
            msg('That is more than the largest residential gas heater delivers. It takes two heaters or a commercial one.');
            go('Request a quote', root.getAttribute('data-quote'));
            return;
          }
          big('Heater size, the next one up', fmt(size) + ' BTU');
          row('Time to raise the water ' + fmt(rise) + 'F', hours(gal * 8.34 * rise / (size * EFF)));
          go('Shop ' + fmt(size) + ' BTU gas heaters', root.getAttribute('data-shop'));
          return;
        }
        var cover = v('cover'), hrs = v('hrs');
        var hw = cover === 0.2 ? 1 : Math.min(wind, 1.25);
        var daily = gal * 8.3 * rise * cover * hw, per = daily / hrs;
        row('Heat to replace each day', fmt(daily) + ' BTU');
        var hp = HP.filter(function (s) { return s >= per; })[0];
        if (!hp) {
          big('Heat pump size', 'Over 143,000 BTU');
          msg('More than one residential heat pump delivers in ' + fmt(hrs) + ' hours a day. A cover, more hours, two heat pumps or a gas heater closes the gap.');
          go('Shop pool heaters', root.getAttribute('data-shop'));
        } else {
          big('Heat pump size, the next one up', fmt(hp) + ' BTU');
          row('Runs, to hold ' + fmt(want) + 'F', hours(daily / hp) + ' a day');
          row('First warm up of ' + fmt(rise) + 'F', hours(gal * 8.34 * rise / hp));
          go('Shop ' + fmt(hp) + ' BTU heat pumps', root.getAttribute('data-shop'));
        }
        if (wind > 1 && cover === 0.2) msg('Under a blanket the worksheet adds nothing for wind, so none is added here.');
        else if (wind > 1.25) msg('The worksheet stops at 5 mph, so the daily heat uses its factor of 1.25. In a stronger wind the heat pump runs longer than shown.');
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  // The pool salt calculator on /pages/pool-salt-calculator. Markup: snippets/aps-salt-calc.liquid.
  //
  //   salt to add, lb = gallons x 8.345 x (level to reach - level now) / 1,000,000
  //
  // 8.345 is the weight of a gallon of water in pounds, and parts per million is by weight, so this is the
  // sum behind every maker's salt table: 10,000 gallons from nothing is 267 lb at 3,200 ppm (Hayward
  // prints 267), 300 lb at 3,600 (Pentair prints 300.43), 250 lb at 3,000 (Jandy and AutoPilot print 250)
  // and 292 lb at 3,500 (Solaxx prints 292). No maker prints the constant; it is what their tables divide
  // out to. The level to reach comes from the system the reader picks and stays editable, because the
  // makers do not agree on one number.
  //
  // Too much salt has one remedy, and it is arithmetic: salt does not leave with evaporation, so the share
  // of the water to replace is 1 - (level wanted / level now). Hayward's service guide prints the same sum
  // in inches of depth: 54 in at 4,500 ppm keeps 54 x 3,200 / 4,500 = 38.4 in, so 29 percent goes.
  //
  // Gallons from the pool's shape use the multipliers the closing sizer already prints on this site:
  // 7.5 for a rectangle, 5.9 for a round pool, 6.7 for an oval.
  function salt() {
    var LB = 8.345;
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    document.querySelectorAll('.gd-hc[data-sc]').forEach(function (root) {
      var out = root.querySelector('[data-sc="out"]');
      var bag = parseFloat(root.getAttribute('data-bag')) || 40;
      var f = function (k) { return root.querySelector('[data-sc="' + k + '"]'); };
      var v = function (k) { return parseFloat(f(k).value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go() { var a = el('a', 'go', root.getAttribute('data-shop-label') || 'Shop salt test kits'); a.href = root.getAttribute('data-shop'); out.appendChild(a); }
      function gallons(mode) {
        if (mode === 'gal') return v('gal');
        var d = v('dep');
        if (mode === 'round') return v('dia') * v('dia') * d * 5.9;
        return v('len') * v('wid') * d * (mode === 'oval' ? 6.7 : 7.5);
      }
      function run(ev) {
        var mode = f('mode').value;
        root.querySelectorAll('[data-sc-m]').forEach(function (e) { e.hidden = e.getAttribute('data-sc-m').split(' ').indexOf(mode) < 0; });
        // Picking a system fills in its level. Typing a level afterwards is left alone.
        if (ev && ev.target === f('sys') && f('sys').value) f('want').value = f('sys').value;
        var gal = gallons(mode), now = v('now'), want = v('want');
        while (out.firstChild) out.removeChild(out.firstChild);
        if (!(gal > 0)) { msg(mode === 'gal' ? 'Enter the pool\'s volume in gallons.' : 'Enter the pool\'s dimensions and its average depth.'); return; }
        if (isNaN(now) || now < 0) now = 0;
        if (!(want > 0)) { msg('Enter the salt level your system asks for.'); return; }
        row('Pool volume', fmt(gal) + ' gallons');
        row('Salt now', fmt(now) + ' ppm');
        row('Level to reach', fmt(want) + ' ppm');
        if (now >= want) {
          big('Salt to add', 'None');
          if (now > want) {
            var share = 1 - want / now;
            msg('The water is already above that level. Salt does not leave with evaporation, so the way down is to replace water: about ' + Math.round(share * 100) + ' percent of the pool, ' + fmt(gal * share) + ' gallons, brings ' + fmt(now) + ' ppm down to ' + fmt(want) + '.');
          } else {
            msg('The water is at the level you chose.');
          }
          go();
          return;
        }
        var lb = gal * LB * (want - now) / 1e6, bags = lb / bag;
        row('To raise', fmt(want - now) + ' ppm');
        big('Salt to add', fmt(lb) + ' lb');
        row('In ' + fmt(bag) + ' lb bags', bags.toFixed(1));
        // Whole bags, and where they land. Rounding up read as an error: 400.56 lb came out as 11 bags when
        // ten bags is 400 lb, and rounding to the nearest bag can overshoot a small pool by 200 ppm. So the
        // whole bags on either side are shown with the level each reaches, and the reader decides. Jandy's
        // TruClear manual: adding more is easier than diluting.
        var at = function (n) { return fmt(Math.round((now + n * bag * 1e6 / (gal * LB)) / 10) * 10) + ' ppm'; };
        var say = function (n) { return n + (n === 1 ? ' bag (' : ' bags (') + fmt(n * bag) + ' lb) ' + (n === 1 ? 'reaches' : 'reach') + ' about ' + at(n) + '.'; };
        var near = Math.round(bags), lo = Math.floor(bags);
        if (near >= 1 && Math.abs(bags - near) <= 0.1) msg(say(near));
        else if (lo < 1) msg('Less than one ' + fmt(bag) + ' lb bag: weigh out ' + fmt(lb) + ' lb. A whole bag reaches about ' + at(1) + '.');
        else msg(say(lo) + ' ' + say(lo + 1));
        go();
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  // The pool pump size calculator on the pump size guide. Markup: snippets/aps-pump-calc.liquid. Sources in
  // docs/ops/2026-10-01-pump-guides/facts-pump-size.md.
  //
  //   flow needed, GPM  = gallons / (turnover hours x 60)
  //   pipe carries, GPM = inside area, sq ft x velocity, ft/s x 448.831     (448.831 GPM in one cubic foot a second)
  //
  // Inside diameters are Schedule 40 PVC's: 1.610, 2.067, 2.469 and 3.068 inches. The velocities come in on the
  // snippet's data attributes, 6 ft/s suction and 8 ft/s return, so the copy and the tool change together.
  function pump() {
    var ID = { '1.5': 1.61, '2': 2.067, '2.5': 2.469, '3': 3.068 };
    var NAME = { '1.5': '1-1/2', '2': '2', '2.5': '2-1/2', '3': '3' };     // as the guide and the dropdown write them
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    var cap = function (d, vel) { return vel * Math.PI * Math.pow(d / 12, 2) / 4 * 448.831; };
    document.querySelectorAll('.gd-hc[data-pc]').forEach(function (root) {
      var out = root.querySelector('[data-pc="out"]');
      var sv = parseFloat(root.getAttribute('data-suction')) || 6, rv = parseFloat(root.getAttribute('data-return')) || 8;
      var f = function (k) { return root.querySelector('[data-pc="' + k + '"]'); };
      // The pumps we sell with a manufacturer's curve read (snippets/aps-pump-calc.liquid, aps.pump_curve). A null is a
      // pump that is out of stock or has no curve.
      var pumps = [];
      try { pumps = JSON.parse((root.querySelector('[data-pc-pumps]') || {}).textContent || '[]').filter(Boolean); } catch (e) { pumps = []; }
      var v = function (k) { return parseFloat(f(k).value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go(text, href) { var a = el('a', 'go', text); a.href = href; out.appendChild(a); }
      function gallons(mode) {
        if (mode === 'gal') return v('gal');
        var d = v('dep');
        if (mode === 'round') return v('dia') * v('dia') * d * 5.9;
        return v('len') * v('wid') * d * (mode === 'oval' ? 6.7 : 7.5);
      }
      function run() {
        var mode = f('mode').value;
        root.querySelectorAll('[data-pc-m]').forEach(function (e) { e.hidden = e.getAttribute('data-pc-m').split(' ').indexOf(mode) < 0; });
        while (out.firstChild) out.removeChild(out.firstChild);
        var gal = gallons(mode), hrs = v('hrs'), pipe = f('pipe').value, d = ID[pipe];
        if (!(gal > 0)) { msg(mode === 'gal' ? 'Enter the pool\'s volume in gallons.' : 'Enter the pool\'s dimensions and its average depth.'); return; }
        var need = gal / (hrs * 60), sx = cap(d, sv), rx = cap(d, rv);
        row('Pool volume', fmt(gal) + ' gallons');
        big('Flow needed', fmt(need) + ' GPM');
        row('Turnover', hrs + ' hours, ' + fmt(need * 60) + ' gallons an hour');
        big('A ' + NAME[pipe] + ' inch suction pipe carries up to', fmt(sx) + ' GPM');
        row('The same size return line, up to', fmt(rx) + ' GPM');
        if (need > sx) {
          // Smallest first, by an explicit list: Object.keys puts integer-like keys ('2', '3') ahead of '1.5' and '2.5'.
          var bigger = ['1.5', '2', '2.5', '3'].filter(function (p) { return cap(ID[p], sv) >= need; })[0];
          msg('That is more than the suction pipe carries at ' + sv + ' feet a second. A longer turnover lowers the flow' + (bigger ? ', or the suction needs ' + NAME[bigger] + ' inch pipe.' : ', or the suction needs a second line or larger pipe.'));
        } else {
          msg('Within what the pipe carries. Look for a pump whose manufacturer\'s curve gives ' + fmt(need) + ' GPM at your plumbing\'s head, or a variable speed pump set to that flow.');
        }
        list(need, sx);
        go(root.getAttribute('data-shop-label') || 'Shop pool pumps', root.getAttribute('data-shop'));
      }
      // A variable speed pump fits when it reaches the flow at the chosen head (it is then set down to it); a single or
      // two speed pump fits when its flow there is between the need and what the suction pipe carries. Closest first.
      function list(need, sx) {
        if (!pumps.length) return;
        var head = (f('head') || {}).value || '50';
        var HEADS = ['30', '40', '50', '60'];
        var fit = pumps.map(function (p) {
          var gpm = (p.c && p.c.gpm) || {}, g = gpm[head], vs = /variable/i.test(p.s || ''), over = false;
          // Where a variable speed pump's curve stops short of a low head, its flow at the next head up is a floor: a pump
          // moves at least as much water against less head. A single speed pump needs the reading itself, for the pipe.
          if (typeof g !== 'number' && vs) {
            for (var i = HEADS.indexOf(head) + 1; i < HEADS.length; i++) {
              if (typeof gpm[HEADS[i]] === 'number') { g = gpm[HEADS[i]]; over = true; break; }
            }
          }
          return { p: p, g: g, vs: vs, over: over };
        }).filter(function (x) {
          return typeof x.g === 'number' && x.g >= need && (x.vs || x.g <= sx);
        }).sort(function (a, b) { return a.g - b.g; }).slice(0, 6);
        var h = el('p', 'msg'); h.style.marginTop = '12px';
        h.appendChild(el('b', null, fit.length ? 'Pumps that deliver ' + fmt(need) + ' GPM at ' + head + ' ft of head' :
          'None of the pumps with a curve on file delivers ' + fmt(need) + ' GPM at ' + head + ' ft of head within what the pipe carries.'));
        out.appendChild(h);
        if (!fit.length) return;
        var ul = el('ul'); ul.style.margin = '6px 0 0'; ul.style.paddingLeft = '18px'; ul.style.fontSize = '13px';
        fit.forEach(function (x) {
          var li = el('li'); li.style.margin = '4px 0';
          var a = el('a', null, x.p.t); a.href = x.p.u; li.appendChild(a);
          li.appendChild(document.createTextNode((x.over ? ', over ' : ', about ') + fmt(x.g) + ' GPM' + (x.vs ? ' at full speed, set lower' : '') + ', ' + x.p.p));
          ul.appendChild(li);
        });
        out.appendChild(ul);
        out.appendChild(el('p', 'msg', 'Flow at top speed, read from each manufacturer\'s performance curve.'));
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  // The accessible entries calculator on the ADA pool lift guide. Markup: snippets/aps-lift-feet.liquid. The rule is
  // section 242 of the 2010 ADA Standards, as recorded in docs/ops/2026-10-12-lift-guides/facts-lift-ada.md:
  //   swimming pool, under 300 linear feet of wall: 1 entry, a lift or a sloped entry
  //   swimming pool, 300 feet or more: 2 entries, the primary a lift or a sloped entry
  //   one point of entry (wave pool, lazy river, sand bottom): 1 entry of any type
  //   wading pool: 1 sloped entry; spa: 1 of lift, transfer wall or transfer system; spa cluster: 5 percent, at least 1
  //   catch pool: none, an accessible route to the edge
  // Linear feet is the wall at the water line: 2 x (length + width) for a rectangle, pi x diameter for a round pool.
  function liftFeet() {
    var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
    document.querySelectorAll('.gd-hc[data-lf]').forEach(function (root) {
      var out = root.querySelector('[data-lf="out"]');
      var f = function (k) { return root.querySelector('[data-lf="' + k + '"]'); };
      var v = function (k) { return parseFloat(f(k).value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function go() { var a = el('a', 'go', root.getAttribute('data-shop-label') || 'Shop ADA pool lifts'); a.href = root.getAttribute('data-shop'); out.appendChild(a); }
      function feet(mode) {
        if (mode === 'feet') return v('feet');
        if (mode === 'round') return Math.PI * v('dia');
        return 2 * (v('len') + v('wid'));
      }
      function run() {
        var kind = f('kind').value, mode = f('mode').value;
        root.querySelectorAll('[data-lf-k]').forEach(function (e) {
          var show = e.getAttribute('data-lf-k') === kind;
          var m = e.getAttribute('data-lf-m');
          if (show && m) show = m.split(' ').indexOf(mode) >= 0;
          e.hidden = !show;
        });
        while (out.firstChild) out.removeChild(out.firstChild);
        if (kind === 'pool') {
          var ft = feet(mode);
          if (!(ft > 0)) { msg(mode === 'feet' ? 'Enter the linear feet of pool wall.' : 'Enter the pool\'s dimensions.'); return; }
          row('Linear feet of wall', fmt(ft) + ' ft');
          if (ft < 300) {
            big('Accessible entries required', '1');
            msg('Under 300 linear feet of wall. The one entry must be a pool lift or a sloped entry, section 242.2. Pool stairs, a transfer wall or a transfer system do not count on their own.');
          } else {
            big('Accessible entries required', '2');
            msg('300 linear feet or more. The primary entry must be a pool lift or a sloped entry. The second may be a lift, a sloped entry, a transfer wall, a transfer system or pool stairs.');
          }
        } else if (kind === 'one') {
          big('Accessible entries required', '1');
          msg('A pool with one point of entry needs one accessible entry of any type, whatever the length of its wall: a lift, a sloped entry, a transfer wall, a transfer system or pool stairs.');
        } else if (kind === 'wading') {
          big('Accessible entries required', '1 sloped entry');
          msg('A wading pool needs a sloped entry. A pool lift does not satisfy the wading pool rule, section 242.3.');
        } else if (kind === 'spa') {
          big('Accessible entries required', '1');
          msg('A spa needs one entry: a pool lift, a transfer wall or a transfer system, section 242.4. A footrest is not required on a spa lift.');
        } else if (kind === 'cluster') {
          var n = v('spas');
          if (!(n >= 1)) { msg('Enter how many spas are in the group.'); return; }
          var need = Math.max(1, Math.ceil(n * 0.05));
          row('Spas in the group', fmt(n));
          big('Spas that need an entry', fmt(need));
          msg('Where spas are grouped, 5 percent of them need an accessible entry, and at least one. Each entry is a pool lift, a transfer wall or a transfer system.');
        } else {
          big('Accessible entries required', 'None');
          msg('A catch pool at the end of a slide needs no accessible entry, only an accessible route to its edge.');
        }
        msg('Each pool and each spa in a facility is counted on its own and needs its own entry whenever it is open, so one portable lift cannot serve a pool and a spa.');
        go();
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }
  // The pool lift selector on the fit guide. Markup: snippets/aps-lift-fit.liquid; the models and their stated ranges are
  // the page's aps.lift_fit json, in a script block the snippet writes. The questions follow S.R. Smith's configurator
  // (where the lift goes, the pool, the deck, the dimensions) across every brand. A model is listed as fitting only when
  // every number the reader entered sits inside a range its manufacturer publishes; a model whose manufacturer prints no
  // range for that number is listed to confirm against its chart, never guessed. docs/ops/2026-10-12-lift-guides/PLAN.md.
  function liftFit() {
    document.querySelectorAll('.gd-hc[data-lfit]').forEach(function (root) {
      var out = root.querySelector('[data-lfit="out"]');
      var models = [];
      try { models = JSON.parse((root.querySelector('[data-lfit-models]') || {}).textContent || '[]'); } catch (e) { models = []; }
      var f = function (k) { return root.querySelector('[data-lfit="' + k + '"]'); };
      var v = function (k) { return parseFloat(f(k).value); };
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function pair(cls, a, b) { var r = el('div', cls); r.appendChild(el('span', null, a)); r.appendChild(el('b', null, b)); out.appendChild(r); }
      function row(a, b) { pair('r', a, b); }
      function big(a, b) { pair('big', a, b); }
      function msg(t) { out.appendChild(el('p', 'msg', t)); }
      function list(title, items) {
        var h = el('p', 'msg'); h.style.marginTop = '12px'; h.appendChild(el('b', null, title)); out.appendChild(h);
        var ul = el('ul'); ul.style.margin = '6px 0 0'; ul.style.paddingLeft = '18px'; ul.style.fontSize = '13px';
        items.forEach(function (x) {
          var li = el('li'); li.style.margin = '4px 0';
          var a = el('a', null, x.m.n + ', ' + x.m.b); a.href = x.m.u; li.appendChild(a);
          li.appendChild(document.createTextNode(': ' + x.m.f + (x.why ? '. ' + x.why : '')));
          ul.appendChild(li);
        });
        out.appendChild(ul);
      }
      function inside(range, x) { return range && x >= range[0] && x <= range[1]; }
      function run() {
        var use = f('use').value, pool = f('pool').value, deck = f('deck').value, cap = v('cap');
        root.querySelectorAll('[data-lfit-p]').forEach(function (e) { e.hidden = e.getAttribute('data-lfit-p').split(' ').indexOf(pool) < 0; });
        var wallPool = pool === 'above' || pool === 'spa';
        var sb = v('setback'), dr = v('draft'), wall = v('wall');
        while (out.firstChild) out.removeChild(out.firstChild);
        if (!models.length) { msg('The selector\'s model list did not load. The table below lists every lift with its range.'); return; }
        var fits = [], confirm = [], hiddenAda = 0, outOfRange = 0;
        models.forEach(function (m) {
          if (use === 'ada' && !m.ada) { hiddenAda++; return; }
          if (m.pool.indexOf(pool) < 0) return;
          if (m.deck.indexOf(deck) < 0) return;
          if (m.cap != null && m.cap < cap) return;
          var open = [];                                   // the numbers this model's manufacturer does not state
          if (m.cap == null) open.push('its capacity');
          if (wallPool) {
            if (m.wall) { if (!inside(m.wall, wall)) { outOfRange++; return; } }
            else open.push('its wall height');
          } else if (m.port !== 'free') {
            if (m.sb) { if (!inside(m.sb, sb)) { outOfRange++; return; } }
            else open.push('its setback');
            if (m.dr != null) { if (dr > m.dr) { outOfRange++; return; } }
            else if (m.sb) open.push('its draft');          // a stated setback with no draft: still a chart check
          }
          if (open.length) confirm.push({ m: m, why: 'Confirm ' + open.join(' and ') + ' on the manufacturer\'s chart' });
          else fits.push({ m: m, why: '' });
        });
        row('Where the lift goes', use === 'ada' ? 'A pool open to the public' : 'A home pool');
        row('Capacity needed', cap + ' lb');
        if (wallPool) row('Wall above the deck', (isNaN(wall) ? '?' : wall) + ' in');
        else row('Setback and draft', (isNaN(sb) ? '?' : sb) + ' in, ' + (isNaN(dr) ? '?' : dr) + ' in');
        big(fits.length === 1 ? 'Lift inside its stated range' : 'Lifts inside their stated range', String(fits.length));
        if (fits.length) list('Fits the numbers you entered', fits);
        if (confirm.length) list('Fits the pool and deck; confirm the numbers', confirm);
        if (!fits.length && !confirm.length) {
          msg('No lift we carry matches that pool, deck and capacity together.' + (outOfRange ? ' ' + outOfRange + (outOfRange === 1 ? ' lift serves' : ' lifts serve') + ' this pool and deck but not at the numbers you entered.' : ''));
        } else if (outOfRange) {
          msg(outOfRange + (outOfRange === 1 ? ' lift serves' : ' lifts serve') + ' this pool and deck but ' + (outOfRange === 1 ? 'its' : 'their') + ' stated range does not reach your numbers, so ' + (outOfRange === 1 ? 'it is' : 'they are') + ' left out.');
        }
        if (deck === 'thin') msg('A slab under 6 in takes Aqua Creek\'s shallow concrete anchor or a portable lift. The other manufacturers ask for the slab to be reinforced to their drawing first.');
        if (deck === 'sleeve') msg('An existing sleeve takes a retrofit model or the manufacturer\'s adapter. Measure the sleeve\'s inside diameter and depth before ordering.');
        if (deck === 'none') msg('A free standing lift needs no deck work. For a public pool it is fixed to the deck with its own kit, which is what the ADA calls a fixed lift.');
        if (use === 'ada' && hiddenAda) msg(hiddenAda + ' lifts whose manufacturer does not state they meet the ADA are left out for a public pool. Choose a home pool to see them.');
        var a = el('a', 'go', use === 'ada' ? 'Shop ADA pool lifts' : 'Shop home pool lifts');
        a.href = root.getAttribute(use === 'ada' ? 'data-shop-ada' : 'data-shop-home'); out.appendChild(a);
      }
      root.addEventListener('input', run); root.addEventListener('change', run); run();
    });
  }

  /* The pool lift configurator (snippets/aps-lift-config.liquid, 2026-10-14). Four steps in one box: the pool,
     deck and lettered measurements; the lifts whose stated ranges hold the numbers, as a comparison table; color,
     anchor and accessories for the chosen lift; the set to the cart with the measurements as line properties.
     The models are the page's aps.lift_config json; the lifts' prices, pictures and variant ids are rendered by
     Liquid from the page's product references; a part's come from /products/<handle>.js when a lift is chosen. */
  function liftConfig() {
    document.querySelectorAll('.gd-hc[data-lc]').forEach(function (root) {
      var MODELS = [], LIFTS = {};
      try { MODELS = JSON.parse((root.querySelector('[data-lc-models]') || {}).textContent || '[]'); } catch (e) { MODELS = []; }
      try { LIFTS = JSON.parse((root.querySelector('[data-lc-lifts]') || {}).textContent || '{}'); } catch (e) { LIFTS = {}; }
      var PROD = {}; Object.keys(LIFTS).forEach(function (h) { PROD[h] = { id: LIFTS[h].id, p: LIFTS[h].price / 100, t: LIFTS[h].title, img: LIFTS[h].img, url: LIFTS[h].url, avail: LIFTS[h].avail }; });
      var f = function (k) { return root.querySelector('[data-lc="' + k + '"]'); }, v = function (k) { return parseFloat(f(k).value); };
      var steps = [].slice.call(root.querySelectorAll('.lc-step')); var state = { model: null, color: null, anchor: null, extras: {} };
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      function money(x) { return '$' + x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
      function open(n) { steps.forEach(function (s, i) { s.classList.remove('open'); if (i + 1 === n) s.classList.add('open'); if (i + 1 > n) { s.classList.add('todo'); s.classList.remove('done'); } }); }
      function inside(r, x) { return r && x >= r[0] && x <= r[1]; }
      function sel(k) { var e = f(k); return e.options[e.selectedIndex].text; }
      function withImg(url, w) { if (!url) return ''; return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
      // a part's live data, by handle, once
      function product(h) {
        if (PROD[h]) return Promise.resolve(PROD[h]);
        return fetch(rootPath + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return null;
          var vr = p.variants[0];
          PROD[h] = { id: vr.id, p: vr.price / 100, t: p.title, img: p.featured_image, url: rootPath + 'products/' + h, avail: vr.available };
          return PROD[h];
        }).catch(function () { return null; });
      }
      steps.forEach(function (s, i) { s.querySelector('.lc-head').addEventListener('click', function () { if (!s.classList.contains('todo')) open(i + 1); }); });
      f('pool').addEventListener('change', function () { var spa = f('pool').value === 'spa'; root.querySelectorAll('[data-lc-spa]').forEach(function (l) { l.hidden = !spa; }); });
      function step1() {
        var use = f('use').value, pool = f('pool').value, deck = f('deck').value, port = f('port').value, cap = v('cap');
        var A = v('A'), S = v('S'), B = v('B'); var wallPool = pool === 'above' || pool === 'spa';
        var fits = [], confirm = [], out = 0, hidden = 0;
        MODELS.forEach(function (m) {
          if (use === 'ada' && !m.ada) { hidden++; return; }
          if (m.pool.indexOf(pool) < 0 || m.deck.indexOf(deck) < 0) return;
          if (m.cap != null && m.cap < cap) return;
          if (port === 'portable' && !(m.port === 'free' || /portable/.test(m.mount || ''))) return;
          if (port === 'fixed' && m.port === 'free') return;
          var q = [];
          if (m.cap == null) q.push('capacity');
          if (wallPool) { if (m.wall) { if (!inside(m.wall, B)) { out++; return; } } else q.push('wall height'); }
          else if (m.port !== 'free') {
            if (m.sb) { if (!inside(m.sb, S)) { out++; return; } } else q.push('setback');
            if (m.dr != null) { if (A > m.dr) { out++; return; } } else if (m.sb) q.push('draft');
          }
          (q.length ? confirm : fits).push({ m: m, q: q });
        });
        steps[0].classList.add('done');
        steps[0].querySelector('[data-sum]').textContent = (use === 'ada' ? 'Public pool' : 'Home pool') + ', ' + sel('pool').toLowerCase() + ', ' + sel('deck').toLowerCase() + '. A ' + A + ' in, S ' + S + ' in' + (wallPool ? ', B ' + B + ' in' : '') + ', ' + cap + ' lb.';
        var box = f('lifts'); while (box.firstChild) box.removeChild(box.firstChild);
        function rng(r, unit) { return r ? r[0] + ' to ' + r[1] + ' ' + unit : ''; }
        var all = fits.concat(confirm);
        if (all.length) {
          box.appendChild(el('p', 'lc-h', fits.length + (fits.length === 1 ? ' lift fits' : ' lifts fit') + ' the numbers you entered' + (confirm.length ? ', ' + confirm.length + ' more fit the pool and deck with a number to confirm' : '')));
          var wrap = el('div', 'gd-tw lc-tw'), tb = el('table', 'gd-cmp gd-4c lc-cmp'), thead = el('thead'), hr = el('tr');
          (wallPool ? ['Lift', 'Capacity', 'Wall', 'Anchor', 'Fit', 'Price'] : ['Lift', 'Capacity', 'Setback', 'Draft', 'Anchor', 'Fit', 'Price']).forEach(function (h) { hr.appendChild(el('th', null, h)); });
          thead.appendChild(hr); tb.appendChild(thead); var tbody = el('tbody');
          all.forEach(function (x) {
            var m = x.m, h = m.u.split('/products/')[1], p = PROD[h] || {}; var tr = el('tr');
            var td = el('td', 'lf'); var im = el('span', 'im'); if (p.img) { var img = document.createElement('img'); img.src = withImg(p.img, 120); img.alt = ''; img.loading = 'lazy'; im.appendChild(img); } td.appendChild(im);
            var nm = el('span', 'nm'); nm.appendChild(el('b', null, m.n)); nm.appendChild(el('span', 'nt', m.b)); td.appendChild(nm); tr.appendChild(td);
            tr.appendChild(el('td', null, m.cap != null ? m.cap + ' lb' : 'Not stated'));
            if (wallPool) tr.appendChild(el('td', null, rng(m.wall, 'in') || 'Not stated'));
            else { tr.appendChild(el('td', null, m.port === 'free' ? 'Free standing' : (rng(m.sb, 'in') || 'Not stated'))); tr.appendChild(el('td', null, m.port === 'free' ? '' : (m.dr != null ? 'To ' + m.dr + ' in' : 'Not stated'))); }
            tr.appendChild(el('td', null, m.port === 'free' ? 'Not needed' : (m.anchor_need === 'included' ? 'Included' : m.anchor_need === 'not needed' ? 'Not needed' : 'Separate')));
            tr.appendChild(el('td', x.q.length ? 'st cf' : 'st ok', x.q.length ? 'Confirm ' + x.q.join(', ') : 'Fits'));
            var pz = el('td', 'pz'); pz.appendChild(el('span', null, p.p ? money(p.p) : '')); var b = el('button', 'gp-btn', 'Choose'); b.type = 'button'; pz.appendChild(b); tr.appendChild(pz);
            tr.addEventListener('click', function () { choose(m, tr); }); tbody.appendChild(tr);
          });
          tb.appendChild(tbody); wrap.appendChild(tb); box.appendChild(wrap);
        } else box.appendChild(el('p', 'lc-note', 'No lift we carry matches that pool, deck and capacity together.' + (out ? ' ' + out + ' serve this pool and deck but not at the numbers you entered.' : '')));
        if (all.length && out) box.appendChild(el('p', 'lc-note', out + (out === 1 ? ' lift serves' : ' lifts serve') + ' this pool and deck but not at the numbers you entered, so ' + (out === 1 ? 'it is' : 'they are') + ' left out.'));
        if (use === 'ada' && hidden) box.appendChild(el('p', 'lc-note', hidden + ' lifts whose manufacturer does not state they meet the ADA are left out for a public pool.'));
        steps[1].classList.remove('todo'); open(2); steps[1].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function choose(m, row) {
        root.querySelectorAll('.lc-cmp tr').forEach(function (t) { t.classList.remove('sel'); }); row.classList.add('sel');
        state.model = m; state.color = (m.colors || [])[0] ? m.colors[0].h : m.u.split('/products/')[1]; state.anchor = null; state.extras = {};
        steps[1].classList.add('done'); steps[1].querySelector('[data-sum]').textContent = m.b + ' ' + m.n;
        var box = f('config'); while (box.firstChild) box.removeChild(box.firstChild);
        var deck = f('deck').value;
        function opts(title, items, kind, radio, note, empty) {
          box.appendChild(el('p', 'lc-h', title)); if (note) box.appendChild(el('p', 'lc-note', note));
          if (!items.length) { box.appendChild(el('p', 'lc-note', empty)); return; }
          var g = el('div', 'lc-opts'); box.appendChild(g);
          items.forEach(function (it) {
            var o = el('label', 'lc-opt'); var inp = document.createElement('input'); inp.type = radio ? 'radio' : 'checkbox'; inp.name = 'lc-' + kind;
            var on = radio && kind === 'color' && state.color === it.h; inp.checked = on; if (on) o.classList.add('sel');
            o.appendChild(inp); var im = el('span', 'im'); o.appendChild(im); var tx = el('span'); var nm = el('b', null, kind === 'color' ? it.l + ' seat' : ''); tx.appendChild(nm); var pz = el('span', 'pz'); tx.appendChild(pz); o.appendChild(tx); g.appendChild(o);
            product(it.h).then(function (p) {
              if (!p) { o.hidden = true; return; }
              if (p.img) { var img = document.createElement('img'); img.src = withImg(p.img, 120); img.alt = ''; im.appendChild(img); }
              if (kind !== 'color') nm.textContent = p.t; pz.textContent = money(p.p);
              if (p.avail === false) { inp.disabled = true; o.classList.add('na'); tx.appendChild(el('span', 'pn', 'Not available right now')); }
            });
            inp.addEventListener('change', function () {
              if (radio) { g.querySelectorAll('.lc-opt').forEach(function (x) { x.classList.remove('sel'); }); o.classList.add('sel'); if (kind === 'color') state.color = it.h; else state.anchor = it.h; }
              else { o.classList.toggle('sel', inp.checked); if (inp.checked) state.extras[it.h] = true; else delete state.extras[it.h]; }
            });
          });
        }
        if ((m.colors || []).length > 1) opts('Color', m.colors, 'color', true, '', '');
        var anchorNote = m.port === 'free' ? 'A free standing lift needs no anchor. For a public pool it is fixed with its own kit.' : deck === 'sleeve' ? 'You chose an existing sleeve: the lift drops into it, or takes the manufacturer\'s adapter. Check the sleeve\'s inside diameter and depth.' : deck === 'thin' ? 'A slab under 6 in takes a shallow anchor where the manufacturer lists one, or a portable lift.' : (m.anchor_need === 'included' ? 'This lift is sold with its anchor.' : 'This lift is sold without an anchor. Choose the one the manufacturer lists for your deck.');
        var kits = (m.extras || []).filter(function (x) { return x.k === 'kit'; });
        opts(m.port === 'free' ? 'Fixing kit' : 'Anchor', m.port === 'free' ? kits : (m.anchors || []), 'anchor', true, anchorNote, m.port === 'free' ? 'The kit is sold with the lift or on its page.' : 'The manufacturer lists no anchor we sell for this lift. Ask us which anchor before ordering.');
        opts('Accessories the manufacturer sells for it', (m.extras || []).filter(function (x) { return x.k !== 'kit'; }), 'extra', false, '', 'Nothing listed for this lift.');
        steps[2].classList.remove('todo'); open(3); steps[2].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function profile() {
        var wallPool = f('pool').value === 'above' || f('pool').value === 'spa';
        var rows = [['Where the lift goes', sel('use')], ['Pool', sel('pool')], ['Deck', sel('deck')], ['Site', sel('site')], ['A, deck to water', v('A') + ' in'], ['S, setback', v('S') + ' in'], ['B, wall above deck', v('B') + ' in'], ['C, curb width', v('C') + ' in'], ['D, gutter width', v('D') + ' in'], ['E, bullnose radius', v('E') + ' in'], ['Capacity', v('cap') + ' lb']];
        if (f('pool').value === 'spa') rows.push(['F, bench seat depth', (isNaN(v('F')) ? '' : v('F') + ' in')], ['G, bench seat to floor', (isNaN(v('G')) ? '' : v('G') + ' in')]);
        return rows;
      }
      function step3() {
        var m = state.model; if (!m) return;
        var picks = [state.color]; if (state.anchor) picks.push(state.anchor); Object.keys(state.extras).forEach(function (h) { picks.push(h); });
        Promise.all(picks.map(product)).then(function (ps) {
          var items = [], left = []; ps.forEach(function (p, i) { if (p && p.avail !== false) items.push({ h: picks[i], p: p }); else if (p) left.push(p.t); });
          steps[2].classList.add('done'); steps[2].querySelector('[data-sum]').textContent = items.length + (items.length === 1 ? ' item' : ' items') + (state.anchor ? ', with anchor' : '');
          var box = f('review'); while (box.firstChild) box.removeChild(box.firstChild);
          var wrap = el('div', 'lc-rev'), left = el('div'), right = el('div', 'lc-tot');
          left.appendChild(el('p', 'lc-h', 'Your deck profile'));
          profile().forEach(function (r) { var d = el('div', 'r'); d.appendChild(el('span', null, r[0])); d.appendChild(el('b', null, r[1])); left.appendChild(d); });
          left.appendChild(el('p', 'lc-h', 'The set')); var tot = 0;
          items.forEach(function (x) { tot += x.p.p; var d = el('div', 'r'); d.appendChild(el('span', null, x.p.t)); d.appendChild(el('b', null, money(x.p.p))); left.appendChild(d); });
          var big = el('div', 'big'); big.appendChild(el('span', null, 'The set, ' + items.length + (items.length === 1 ? ' item' : ' items'))); big.appendChild(el('b', null, money(tot))); right.appendChild(big);
          var go = el('button', 'go', 'Add the set to cart'); go.type = 'button'; right.appendChild(go);
          right.appendChild(el('p', 'fine', 'The deck measurements are attached to the lift on the order. The manufacturer confirms the profile before the lift is built.'));
          if (left.length) right.appendChild(el('p', 'fine', 'Not available right now, so not in the set: ' + left.join('; ') + '.'));
          go.addEventListener('click', function () {
            go.disabled = true; go.textContent = 'Adding';
            var props = {}; profile().forEach(function (r) { if (r[1]) props[r[0]] = r[1]; }); props['Configured on'] = 'Pool lift configurator';
            var lines = items.map(function (x, i) { return i === 0 ? { id: x.p.id, quantity: 1, properties: props } : { id: x.p.id, quantity: 1 }; });
            fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
              .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'add failed'); return j; }); })
              .then(function () {
                go.textContent = 'Added to cart';
                var e = new CustomEvent('shopify:cart:lines-update', { bubbles: true }); e.action = 'add'; e.source = 'aps-lift-config';
                e.lines = lines.map(function (l) { return { quantity: 1, merchandiseId: 'gid://shopify/ProductVariant/' + l.id }; }); e.promise = Promise.resolve(); document.dispatchEvent(e);
                var a = el('a', 'go', 'View the cart'); a.href = rootPath + 'cart'; right.insertBefore(a, go.nextSibling);
              })
              .catch(function (err) { go.disabled = false; go.textContent = 'Add the set to cart'; right.insertBefore(el('p', 'fine', 'The cart did not take the set' + (err && err.message && err.message !== 'add failed' ? ': ' + err.message : '') + '. Try again, or add the lift from its page.'), go.nextSibling); });
          });
          wrap.appendChild(left); wrap.appendChild(right); box.appendChild(wrap);
          steps[3].classList.remove('todo'); open(4); steps[3].scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      var nexts = root.querySelectorAll('[data-lc-next]');
      nexts.forEach(function (b) { b.addEventListener('click', b.getAttribute('data-lc-next') === '1' ? step1 : step3); });
    });
  }
  function init() { toc(); calc(); sizer(); igsizer(); heat(); salt(); pump(); liftFeet(); liftFit(); liftConfig(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
